import { RootState } from 'duck/store'
import { createSelector } from 'reselect'

import { getDataState } from '../selectors'
import { Deal, DEALS_STORE_ID } from './types'

const getDealsState = createSelector(getDataState, (dataState) => dataState[DEALS_STORE_ID])

export const getAllDeals = createSelector(getDealsState, (dealsStage) => dealsStage.items)

export const getDeal = (state: RootState, dealId: Deal['id'] | undefined) => {
  if (!dealId) {
    return undefined
  }
  return createSelector(getAllDeals, (allDeals) => allDeals[dealId])(state)
}
